import { trackEvent } from '@domain/analytics/trackEvent';
import { EventMykissCardClicked } from '@generated/events';

export const sendCardClickedEvent = (properties: EventMykissCardClicked['properties']): void => {
  trackEvent({
    name: 'mykiss_card_clicked',
    properties,
  });
};
